import {
	booleanAttribute,
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "./common-imports"
import { ApiService } from "./services/api.service"
import { GenTableAddItemComponent } from "./gen-table-add-item/gen-table-add-item.component"
import { ModalWrapComponent } from "./modal-wrap/modal-wrap.component"

@Component({
	selector: "app-get-headture-row",
	imports: [COMMON_IMPORTS, ModalWrapComponent, GenTableAddItemComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@if (isModalOpen) {
			<app-modal-wrap
				(onClose)="isModalOpen = false; onDone.emit(null)"
				title="headtures"
				modalWrapperClass="modal-fit-content"
			>
				<app-gen-table-add-item
					(onClose)="isModalOpen = false; onDone.emit($event)"
					tableName="headtures"
					restrictedAddMode
					filterField="header_default"
					[filterFieldValue]="isPrescription ? 'p' : 'i'"
					[filterFieldApiObject]="{
						lang: isTranslation ? 'en' : 'iw',
					}"
					[newRowInjectedFields]="
						isTranslation ? [{ name: 'lang', value: 'en' }] : []
					"
				/>
			</app-modal-wrap>
		}
	`,
})
export class GetHeadtureRowComponent {
	@Input({ transform: booleanAttribute }) isTranslation: boolean = false
	@Input({ transform: booleanAttribute }) isPrescription: boolean = false
	@Output() onDone = new EventEmitter()
	isModalOpen: boolean = false

	constructor(private apiService: ApiService) {}

	async ngOnInit() {
		const sendObj: any = {
			filterField: "header_default",
			filterFieldValue: this.isPrescription ? "p" : "i",
			filterFieldApiObject: {
				lang: this.isTranslation ? "en" : "iw",
			},
		}
		const { headtures } = await this.apiService.get_gen_items(
			"headtures",
			sendObj
		)
		const row = headtures.at(0)
		if (row) {
			this.onDone.emit(row)
			return
		}
		this.isModalOpen = true
	}
}
